import useEvent from 'react-use-event-hook'

type AnyFunction = (...args: any[]) => any

// This is just a wrapper on top of useEvent, because useEvent is a bit confusing naming to use.
// More on useEvent: https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
// Was added in React 19 as useEffectEvent: https://react.dev/reference/react/useEffectEvent

/**
 * A hook that returns a function that will not change between renders and
 * has access to the latests props/state at the time of execution.
 *
 * @param fn The function to memoize.
 * @returns A memoized version of the function.
 */
export const useFunction = <T extends AnyFunction>(fn: T) => {
  return useEvent(fn)
}
